<template>
  <div class="p-10 space-y-8">
    <NSeparator class="mx-2" />
    <NSeparator label="OR" class="mx-2" />
  </div>
</template>
